module.exports = __webpack_public_path__ + "2bb2bcb08862b08798e08774be06d8a6.png";